module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('span', {
    staticClass: "label-success label"
  }, [_vm._v(_vm._s(_vm.good))]), _vm._v(" "), _c('span', {
    staticClass: "label-danger label"
  }, [_vm._v(_vm._s(_vm.bad))]), _vm._v(" "), _c('span', {
    staticClass: "label-default label"
  }, [_vm._v("Total " + _vm._s(_vm.fileData.length))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d3acbee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/quote/components/QuoteBatchLabels.vue
// module id = 2175
// module chunks = 1